import {Component, OnDestroy} from '@angular/core';
import {NavigationStart, Router, RouterOutlet} from '@angular/router';
import {filter, Subject, takeUntil} from 'rxjs';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SessionExpiredService} from './services/session-expired.service';
import {BusyService} from './services/busy.service';
import {SystemStatePanelComponent} from './shared/system-state-panel/system-state-panel.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet,
        CommonModule,
        FormsModule,
        SystemStatePanelComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnDestroy {
  title = 'secureentry-ui';
  sessionExpiredVisible$ = this.sessionExpiredService.visible$;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private sessionExpiredService: SessionExpiredService,
    private router: Router,
    private busyService: BusyService
  ) {
    this.router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.busyService.forceIdle();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loginAgain() {
    this.sessionExpiredService.loginAgain();
  }
}
